import '../less/VideoCountdown.less';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import i18n from '../../../common/i18n';
import moment, { Duration } from 'moment';

interface VideoCountdownProps {
    startTime: string;
    restart: () => void;
}

interface OrangeNumberBoxProps {
    time: number;
    dateName: string;
}

interface BlinkingColonProps {
    display: boolean;
}

const OrangeNumberBox = ({ time, dateName }: OrangeNumberBoxProps) => {
    return (
        <div className="flex flex-col items-center">
            <div className="nui-video-countdown-number bg-orange c-white text-bold flex justify-center items-center br-radius-2">
                {time}
            </div>
            <span className="c-black-60 pt-2 uppercase fs-13">{dateName}</span>
        </div>
    );
};
const BlinkingColon = ({ display }: BlinkingColonProps) => {
    return display ? <div className="flex blinking-colon pb-20 px-5 c-black-30">:</div> : <div className="px-10" />;
};

const calculateDiff = startTime => moment(startTime).diff(moment());

const VideoCountdown = ({ startTime, restart }: VideoCountdownProps) => {
    const [duration, setDuration] = useState(calculateDiff(startTime));
    const timerRef = useRef(null);

    const timerFunction = useCallback(() => {
        setDuration(calculateDiff(startTime));
    }, [startTime]);

    useEffect(() => {
        timerRef.current = setInterval(timerFunction, 1000);

        return () => {
            clearInterval(timerRef.current);
        };
    }, [startTime, timerFunction]);
    const time: Duration = moment.duration(duration);

    if (time.asMilliseconds() <= 0) {
        clearInterval(timerRef.current);
        restart();
        return null;
    }
    return (
        <div className="nui-video-countdown-background flex items-center flex-col justify-center">
            <div className="nui-video-countdown-text flex c-black-10 fs-16 uppercase items-center justify-center pb-15">
                {i18n('nui.videocountdown.videostart')}
            </div>
            <div className="nui-video-countdown-row flex c-white items-center full-width justify-center">
                <OrangeNumberBox time={time.days()} dateName={i18n('nui.videocountdown.days')} />
                <BlinkingColon display={false} />
                <OrangeNumberBox time={time.hours()} dateName={i18n('nui.videocountdown.hours')} />
                <BlinkingColon display />
                <OrangeNumberBox time={time.minutes()} dateName={i18n('nui.videocountdown.minutes')} />
                <BlinkingColon display />
                <OrangeNumberBox time={time.seconds()} dateName={i18n('nui.videocountdown.seconds')} />
            </div>
        </div>
    );
};

export default VideoCountdown;
